module.exports = __webpack_public_path__ + "static/mt-carmel-4d987bc5704c8e5fd665a31fe2e5fbe7.png";